module.exports = __webpack_public_path__ + "static/media/VMWM_IPO_System_Data_Protection_Privacy_Policy.5ca9ae7c.pdf";